'use client';

export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{ padding: 24, fontFamily: 'ui-sans-serif, system-ui' }}>
      <h1>Application Error</h1>

      <p style={{ opacity: 0.8, marginTop: 12 }}>Message:</p>
      <pre style={{ whiteSpace: 'pre-wrap' }}>{error?.message || 'No message'}</pre>

      <p style={{ opacity: 0.6, marginTop: 12 }}>Digest: {error?.digest ?? '-'}</p>

      <button
        onClick={reset}
        style={{
          marginTop: 16,
          padding: '10px 14px',
          borderRadius: 10,
          border: '1px solid rgba(0,0,0,0.15)',
          cursor: 'pointer'
        }}
      >
        Retry
      </button>
    </div>
  );
}
